import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';

export const getUserAttributes = async () => {
  try {
    const session = await Auth.currentSession();
    const payload = session.getIdToken().payload;

    const country = payload?.address?.formatted ?? '';

    return {
      country,
      username:
        payload?.identities?.[0]?.userId ??
        payload?.['cognito:username']?.replace('AmazonFederate_', '') ??
        '',
      email: payload?.email ?? '',
    };
  } catch (error) {
    return { country: '', username: '', email: '' };
  }
};

export const useUserAttributes = () => {
  const [attributes, setAttributes] = useState({
    country: '',
    username: '',
    email: '',
  });

  useEffect(() => {
    getUserAttributes().then(setAttributes);
  }, []);

  return attributes;
};
